import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import MagicLinkVerify from './pages/MagicLinkVerify';
import Dashboard from './pages/Dashboard';
import Claims from './pages/Claims';
import ClaimDetail from './pages/ClaimDetail';
import FAQs from './pages/FAQs';
import Communications from './pages/Communications';
import Uploads from './pages/Uploads';
import AdditionalInfo from './pages/AdditionalInfo';
import ErrorPage from './pages/ErrorPage';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import StatusMappings from './pages/admin/StatusMappings';
import FAQManagement from './pages/admin/FAQManagement';
import AdminLayout from './components/AdminLayout';
import './App.css';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return user ? children : <Navigate to="/login" />;
};

const AdminRoute = ({ children }) => {
  const token = localStorage.getItem('adminToken');
  return token ? children : <Navigate to="/admin/login" />;
};

function AppRoutes() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route
        path="/login"
        element={user ? <Navigate to="/dashboard" /> : <Login />}
      />
      <Route
        path="/register"
        element={user ? <Navigate to="/dashboard" /> : <Register />}
      />
      <Route
        path="/auth/verify"
        element={<MagicLinkVerify />}
      />
      <Route
        path="/error"
        element={<ErrorPage />}
      />
      <Route
        path="/admin/login"
        element={<AdminLogin />}
      />
      <Route
        path="/admin"
        element={
          <AdminRoute>
            <AdminLayout />
          </AdminRoute>
        }
      >
        <Route index element={<Navigate to="/admin/dashboard" />} />
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="status-mappings" element={<StatusMappings />} />
        <Route path="faqs" element={<FAQManagement />} />
      </Route>
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/claims"
        element={
          <PrivateRoute>
            <Claims />
          </PrivateRoute>
        }
      />
      <Route
        path="/claims/:reference"
        element={
          <PrivateRoute>
            <ClaimDetail />
          </PrivateRoute>
        }
      />
      <Route
        path="/faqs"
        element={
          <PrivateRoute>
            <FAQs />
          </PrivateRoute>
        }
      />
      <Route
        path="/communications"
        element={
          <PrivateRoute>
            <Communications />
          </PrivateRoute>
        }
      />
      <Route
        path="/uploads"
        element={
          <PrivateRoute>
            <Uploads />
          </PrivateRoute>
        }
      />
      <Route
        path="/additional-info"
        element={
          <PrivateRoute>
            <AdditionalInfo />
          </PrivateRoute>
        }
      />
      <Route
        path="/claims/:reference/additional-info"
        element={
          <PrivateRoute>
            <AdditionalInfo />
          </PrivateRoute>
        }
      />
      <Route
        path="/claims/:reference/communications"
        element={
          <PrivateRoute>
            <Communications />
          </PrivateRoute>
        }
      />
      <Route
        path="/claims/:reference/attachments"
        element={
          <PrivateRoute>
            <Uploads />
          </PrivateRoute>
        }
      />
      <Route path="/" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;
